import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import './styles.scss';
import FeedbackForm from "../../forms/FeedbackForm";

class FeedbackModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  getInitialValues = profile => ({
    email: profile && profile.email,
    name: profile.first_name && profile.last_name && `${profile.first_name} ${profile.last_name}`,
  })

  render() {
    const { buttonLabel, className, profile, submitForm } = this.props;
    const { modal } = this.state;

    return (
      <React.Fragment>
        <a className="dropdown-menu-link" onClick={this.toggle}>{buttonLabel}</a>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
          className={className}
          size="md"
        >
          <ModalBody className="feedback-modal-body">
            <FeedbackForm
              initialValues={profile ? this.getInitialValues(profile): {}}
              toggleModal={this.toggle}
            />
            </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect(
  ({ profile }) => ({ profile: profile.profile })
)(FeedbackModal);



// WEBPACK FOOTER //
// ./src/components/modals/FeedbackModal/FeedbackModal.jsx